import cx from 'clsx';
import React from 'react';

import { ReactComponent as RemoveIcon } from '@assets/svg/cross.svg';

import { MODAL_NAMES } from '@constants/modalRenderers';

import type { IFile } from '@model/file';

import { useModalActions } from '@store/useModalStore';

import FilePreviewIcon from '../FilePreviewIcon/FilePreviewIcon';
import style from './style.module.scss';

interface IProps {
  file: IFile;
  removeFile: (file: IFile) => void;
}

const FilePreview = ({ file, removeFile }: IProps) => {
  const { setActiveModal } = useModalActions();

  const checkImage = file.extension === 'png' || file.extension === 'jpeg' || file.extension === 'jpg';

  const getPreview = () => {
    if (checkImage) {
      setActiveModal({
        name: MODAL_NAMES.lightboxModal,
        options: {
          index: 0,
          images: checkImage ? [{ src: file.url || file.src }] : [],
        },
      });
    }
  };

  return (
    <div className={style.previewItem}>
      <div
        className={cx(style.attachFilePreview, { [style.cursorPointer]: checkImage })}
        onClick={getPreview}
      >
        <FilePreviewIcon file={file} />
        <span className={style.fileText}>
          {checkImage ? `${file.extension} as a photo preview` : file.name}
        </span>
      </div>
      {removeFile && <RemoveIcon className={style.removeFileIcon} onClick={() => removeFile(file)} />}
    </div>
  );
};

export default FilePreview;
